/*eslint-disable*/ 
import './App.css';
import { useState } from 'react';

function App() {
  let [listName, reListName] = useState(['예시1'])
  let [good, reGood] = useState([0])
  let [modal, setModal] = useState(false)
  let [titleNo, setTitleNo] = useState(0)
  let [addList, setAddList] = useState('')
  let [addCont, setAddCont] = useState('예시 내용입니다.')

  // let [date, reDate] = useState('')


  return (
    <>
      <header>
        <h1>근선 블로그 🐱‍🏍✨</h1>
      </header>

      <div class='top_btnBox'>
      {/* 제목 가나다 순 정렬하기 버튼 */}
      <button onClick={()=>{
        let copy = [...listName]
        copy.sort()
        reListName(copy)
      }}>가나다순</button>

      {/* 날짜순 정렬하기 버튼 */}
      <button onClick={()=>{
        let copy = [...date]
        copy.sort()
        reDate(copy)
      }}>최신등록순</button>

      </div>

      {
        modal == true ? <Modal listName={listName} titleNo={titleNo} addCont={addCont}/> : null
      }

      {
        listName.map((a,i)=>{
          return(
            <div className="list" key={i}>
              <p className='listName' onClick={()=>{
                setModal(!modal)
                setTitleNo(i)
              }}>{a}</p>
              <p className='good'><span onClick={()=>{
                let copy = [...good]
                copy[i] = copy[i]+1
                reGood(copy)
              }}>💖</span> {good[i]} </p>
              <p className='date'>7월 15일</p>

              {/* 삭제버튼 */}
              <button className='delete' onClick={()=>{
                let copy = [...listName]
                copy.splice(i,1)
                reListName(copy)

                let copy2 = [...good]
                copy2.splice(i,1)
                reGood(copy2)
              }}>삭제</button> 
              
           </div>
          )
        })
      }

      {/* 새로운 글 등록 */}
      <div className="input">

        <input type='text' placeholder='제목 입력창' onChange={(e)=>{
          setAddList(e.target.value)
        }} />
        <input type='text' placeholder='내용 입력창' className='txt_box' onChange={(e)=>{
          setAddCont(e.target.value)
        }} />

        <button className='submit' onClick={()=>{
          let copy = [...listName]
          copy.unshift(addList)
          reListName(copy)

          let copy2 = [...good]
          copy2.unshift(0)
          reGood(copy2)

          let copy3 = [...addCont]
          copy3.unshift(addCont)
          setAddCont(copy3)

        }}>등록</button>

      </div>

    </>  
  );
}

// 모달창 컴포넌트
function Modal(props){
  return(
    <>
      <div className='Modal'>
        <h4>{props.listName[props.titleNo]}</h4>
        <p>{props.addCont[props.titleNo]}</p>
        <p>7월 15일</p>
      </div>
    </>
  )
}

export default App;
